import { render, staticRenderFns } from "./FormPartCertify.vue?vue&type=template&id=61876688&scoped=true"
import script from "./FormPartCertify.vue?vue&type=script&lang=js"
export * from "./FormPartCertify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61876688",
  null
  
)

export default component.exports